import React from 'react';
import styled from 'styled-components';

import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import { numberFormat } from '@airasia-common/libraries/i18n/LocaleHelper';

import Text from '../Text/Text';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';

import GuestRatingPropTypes from './GuestRating.propTypes';

const RatingNumberWrapper = styled(Row)`
  align-items: center;
  background-color: ${({ theme, move }) =>
    move ? theme.colors.secondaryMove : theme.colors.secondary};
  margin-right: 4px;
  border-radius: 3px;
`;
RatingNumberWrapper.defaultProps = {
  padding: ['4px', '5px'],
};

RatingNumberWrapper.displayName = 'RatingNumberWrapper';

const RatingNumber = styled(Text)`
  color: ${({ theme }) => theme.colors.greyLight};
  font-weight: 400;
  line-height: 10px;

  ${({ bold, theme }) =>
    bold &&
    `
      color: ${theme.colors.primaryWhite};
      font-weight: 500;
    `}
`;

RatingNumber.displayName = 'RatingNumber';
RatingNumber.defaultProps = {
  fontSize: ['12px', '14px'],
};

const RatingLabel = styled(Text)`
  color: ${({ theme }) => theme.colors.secondary};
  font-weight: 500;
  line-height: 18px;
`;

RatingLabel.defaultProps = {
  fontSize: ['12px', '14px'],
  numberOfLines: 1,
};

RatingLabel.displayName = 'RatingLabel';

const RatingCount = styled(Text)`
  color: ${({ theme }) => theme.colors.greyDark};
  font-weight: 400;
  white-space: nowrap;
`;

RatingCount.defaultProps = {
  fontSize: ['10px', '12px'],
  lineHeight: '18px',
};

RatingCount.displayName = 'RatingCount';

const GuestRating = ({
  rating,
  maxRating = 5,
  ratingLabel,
  reviewCount,
  showInline = false,
  move,
}) => {
  return (
    <Wrapper
      marginTop={12}
      display={'flex'}
      flexDirection={showInline ? 'row' : ['column', 'row']}
    >
      <Row>
        <RatingNumberWrapper move={move}>
          <RatingNumber className="guest-rating" bold marginRight={0}>
            {rating}
          </RatingNumber>
          <RatingNumber className="max-score">/{maxRating}</RatingNumber>
        </RatingNumberWrapper>
        {ratingLabel ? (
          <RatingLabel className="rating-label">{ratingLabel}</RatingLabel>
        ) : null}
      </Row>
      {reviewCount > 0 && (
        <Row marginLeft={showInline ? '5px' : [0, '5px']}>
          <RatingCount className="rating-count">
            {`(${translate('common.reviews', {
              smart_count: reviewCount,
              count: numberFormat(reviewCount),
            })})`}
          </RatingCount>
        </Row>
      )}
    </Wrapper>
  );
};

GuestRating.propTypes = GuestRatingPropTypes;

export default GuestRating;
